import React from "react";
import { Link } from "react-router-dom";
import { Phone, Clock, MapPin, ShoppingBag } from "lucide-react";
import { restaurantInfo } from "../data/mock";
import Reveal from "../components/Reveal";
import { useI18n } from "../data/i18n";

const DiamondDivider = () => (
  <div className="flex items-center justify-center gap-2 my-4">
    <div className="w-12 h-px bg-gradient-to-r from-transparent to-[#e4c590]"></div>
    <span className="diamond-mark"></span>
    <span className="diamond-mark opacity-60"></span>
    <span className="diamond-mark"></span>
    <div className="w-12 h-px bg-gradient-to-l from-transparent to-[#e4c590]"></div>
  </div>
);

const Order = () => {
  const { t } = useI18n();

  return (
    <div className="bg-[#0a0a0a] pt-32 pb-24 min-h-screen relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <Reveal direction="up">
          <p className="section-label">{t("order.label")}</p>
          <h1 className="display text-5xl md:text-7xl text-[#f5f0e6] mt-3 mb-2">{t("order.title")}</h1>
          <DiamondDivider />
          <p className="text-[#cfc7b8] italic text-lg mb-12">{t("order.phone_only")}</p>
        </Reveal>

        <Reveal direction="up" delay={200}>
          <div className="bg-[#0f0f0f] border border-[#1f1f1f] p-10 lg:p-16 mb-12">
            <div className="w-20 h-20 mx-auto mb-6 border border-[#e4c590]/40 rounded-full flex items-center justify-center">
              <Phone size={36} className="text-[#e4c590]" />
            </div>
            <p className="text-[#cfc7b8] mb-6">{t("order.call_to_order")}</p>
            <a href={`tel:${restaurantInfo.phone}`} className="cb-btn cb-btn-gold inline-block text-base">
              <span className="cb-btn-text cb-btn-text-1">{restaurantInfo.phone}</span>
              <span className="cb-btn-text cb-btn-text-2" aria-hidden="true">{restaurantInfo.phone}</span>
            </a>
            <p className="text-[#7a7468] text-sm mt-4">{t("order.click_to_call")}</p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <Reveal direction="left" delay={300}>
            <div className="bg-[#0f0f0f] border border-[#1f1f1f] p-8 h-full">
              <Clock size={28} className="text-[#e4c590] mx-auto mb-4" />
              <h3 className="text-[#e4c590] uppercase tracking-widest text-xs mb-3">{t("order.hours_label")}</h3>
              <p className="text-[#f5f0e6]">{t("common.opening_hours")}</p>
            </div>
          </Reveal>
          <Reveal direction="right" delay={400}>
            <div className="bg-[#0f0f0f] border border-[#1f1f1f] p-8 h-full">
              <MapPin size={28} className="text-[#e4c590] mx-auto mb-4" />
              <h3 className="text-[#e4c590] uppercase tracking-widest text-xs mb-3">{t("res.location")}</h3>
              <p className="text-[#f5f0e6]">{t("contact.street")}</p>
              <p className="text-[#cfc7b8]">{t("contact.city")}</p>
            </div>
          </Reveal>
        </div>

        <Reveal direction="up" delay={500}>
          <p className="text-[#a8a297] text-sm mb-10">{t("order.delivery_note")}</p>

          <Link to="/menu/items" className="cb-btn cb-btn-outline inline-flex items-center gap-2">
            <span className="cb-btn-text cb-btn-text-1 inline-flex items-center gap-2">
              <ShoppingBag size={14} /> {t("order.see_menu_first")}
            </span>
            <span className="cb-btn-text cb-btn-text-2 inline-flex items-center gap-2" aria-hidden="true">
              <ShoppingBag size={14} /> {t("order.see_menu_first")}
            </span>
          </Link>
        </Reveal>
      </div>
    </div>
  );
};

export default Order;
